var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamembert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.19434C10.0506 1.19434 11.0909 1.40126 12.0615 1.8033C13.0321 2.20534 13.914 2.79461 14.6569 3.53748C15.3997 4.28035 15.989 5.16227 16.391 6.13287C16.7931 7.10348 17 8.14377 17 9.19434M9 1.19434V9.19434M9 1.19434C4.58172 1.19434 1 4.77606 1 9.19434C1 13.6126 4.58172 17.1943 9 17.1943C13.4183 17.1943 17 13.6126 17 9.19434M9 1.19434C13.4183 1.19434 17 4.77606 17 9.19434M17 9.19434L9 9.19434M17 9.19434C17 10.4568 16.7012 11.7014 16.1281 12.8263C15.5549 13.9511 14.7237 14.9244 13.7023 15.6665L9 9.19434",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamembert);
export default __webpack_public_path__ + "static/media/camembert.0164be068a6a25c08aced204eb2f3a48.svg";
export { ForwardRef as ReactComponent };